import { addMonths } from 'date-fns';
import { ProductType } from '~/models/product/ProductType';
import type { NgtAvailabilityResponseYes, SanityBroadbandProduct } from './internet.api';
import type { InternetProductWithBundleId, InternetServiceOrderProduct } from './useInternetStore';

export const toProductBundle = (ngtProduct: InternetServiceOrderProduct, sanityProduct: SanityBroadbandProduct): InternetProductWithBundleId => {
  const pkg = ngtProduct;
  const product: InternetProductWithBundleId = {
    id: 'internet-product',
    bundleId: 'internet-bundle',
    isPreChosen: false,
    // @ts-expect-error
    displayData: {
      name: sanityProduct.name,
    },
    productType: ProductType.Internet,
    offer: {
      commercialProductId: sanityProduct.iccProductId,
      compositeId: `${sanityProduct.iccProductId}-0-0-12-${sanityProduct.iccAlacarteId}`,
      contractPeriod: 12,
      offerId: 0,
      listPriceId: 0,
      channelIds: sanityProduct.iccAlacarteId ? [sanityProduct.iccAlacarteId] : [],
    },
    pricing: {
      isRecurring: true,
      price: pkg.productPrice,
      originalPrice: pkg.originalProductPrice,
      offerPeriodInMonths: 12,
      offerEndDate: addMonths(new Date(), 12).toISOString(),
    },
  };
  return product;
};

export const getInstallationAddress = (availabilityResponse: NgtAvailabilityResponseYes) => {
  const addressList = availabilityResponse.availabilityInfo.addresses;
  if (addressList.length === 1) {
    return addressList[0];
  }
  // There might be multiple addresses, if that happens we've been told by NGT to use the first one that has "apartment" set. Fallback to first in list.
  return addressList.find((a) => !!a.address.apartment) ?? addressList[0];
};
